/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import bg from "../../assets/bg_image/banner.png";
import CustomPlaybutton from "../../components/Buttons/CustomPlaybutton";
import Button from "../../components/Buttons/Button";
import Section from "../../components/Web series section/SectionNew";
import Tvcs from "../../components/TVC_Section/Tvcs";
import Contact from "../../components/contact/Contact";
import ShortFilms from "../../components/shortfilms/ShortFilms";
import "./Home.scss";
import Partners from "../../components/ourpartnersNew/Partners";
import { useNavigate } from "react-router-dom";
import Tvcsyt from "../../components/TVC_Section/TvcsYtNew";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const HomewithYt = () => {
  const textRef = useRef(null);
  const navigate = useNavigate();

  const youtubeVideoId = "khEqOLAdr5o";

  const splitText = (text) => {
    return text.split(" ").map((word, wordIndex) => (
      <span key={wordIndex} className="word">
        {word.split("").map((char, charIndex) => (
          <span
            key={charIndex}
            className="letter inline uppercase bg-[#484848] bg-clip-text text-transparent"
            style={{ "--index": charIndex }}
          >
            {char}
          </span>
        ))}
        &nbsp;
      </span>
    ));
  };

  useLayoutEffect(() => {
    const letters = textRef.current.querySelectorAll(".letter");

    const animation = gsap.to(letters, {
      stagger: 0.05,
      backgroundImage: "linear-gradient(180deg, #71bf52, #22ad86)",
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 70%",
        end: "bottom 50%",
        scrub: true,
        // markers: true,
      },
    });
    return () => animation.kill();
  }, []);

  return (
    <div className="w-full h-full grid grid-cols-1 m-0 p-0 overflow-hidden relative">
      <div className="w-screen relative aspect-video overflow-hidden">
        <iframe
          src={`https://www.youtube.com/embed/${youtubeVideoId}?playlist=${youtubeVideoId}&rel=0&autoplay=1&mute=1&loop=1&controls=0&playsinline=1`}
          width={1920}
          height={1080}
          className="absolute w-full h-full scale-105"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ pointerEvents: "none" }}
        ></iframe>
      </div>

      <div className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px] w-full h-full font-bebas_neue flex items-start flex-col justify-between">
        <p
          className=" md:text-[5.73vw] text-[11.2vw] tracking-normal opacity-100 text-left break-keep whitespace-pre-line leading-[1.2] text-wrap"
          ref={textRef}
        >
          {/* {splitText(
            "At R.A.T Films, filmmaking is more than a craft—it's our passion. From ad commercials to feature films and web series, we bring bold ideas to life with energy and innovation. Every project is a fresh, dynamic experience designed to captivate, create unforgettable experiences, and make an impact. With top-tier talent and seamless execution, we create films that stand out."
          )} */}
          {splitText(
            "At R.A.T Films, we turn ideas into standout stories—ads, features, or web series—made with passion, powered by top-tier talent and seamless execution"
          )}
        </p>
        <div
          className="flex items-start md:pl-[0.3vw] pl-0 pt-8 md:pt-[5.5vh] "
          // data-aos="fade-up"
        >
          <Button
            buttonText={"KNOW MORE"}
            onClick={() => navigate("/about-us")}
          />
        </div>
      </div>

      {/* Rest of your component */}
      <Section />
      <Tvcsyt />
      <ShortFilms />
      <Partners />
      <Contact />
    </div>
  );
};

export default HomewithYt;
